import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-m-4" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  for: "javaClassName",
  class: "kn-material-input-label"
}
const _hoisted_4 = {
  key: 0,
  class: "p-error p-grid"
}
const _hoisted_5 = { class: "p-col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", _hoisted_2, [
      _createVNode(_component_InputText, {
        id: "javaClassName",
        class: ["kn-material-input", {
                    'p-invalid': !_ctx.javaClass.name && _ctx.dirty
                }],
        type: "text",
        modelValue: _ctx.javaClass.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.javaClass.name = $event)),
        modelModifiers: { trim: true },
        maxLength: "160",
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dirty = true)),
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
      }, null, 8, ["modelValue", "class"]),
      _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.lovsManagement.javaClassName')) + " * ", 1)
    ]),
    (!_ctx.javaClass.name && _ctx.dirty)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("small", _hoisted_5, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('managers.lovsManagement.javaClassName') })), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}